/*!
 * CHIEF - Cybersecurity Learning Platform (PROPRIETARY SOFTWARE)
 * Layout Component
 * 
 * Copyright (c) 2025 Srivatsan Sk. All rights reserved.
 * 
 * PROPRIETARY LICENSE NOTICE:
 * This software is the exclusive proprietary property of Srivatsan Sk.
 * Licensed to client under strict commercial license agreement.
 * Unauthorized use, copying, modification, distribution, or removal
 * of copyright notices is strictly prohibited.
 * 
 * Original Author: Srivatsan Sk
 * License: Proprietary/Commercial
 * Status: Confidential
 * 
 * WARNING: This code contains proprietary business logic and algorithms.
 * Reverse engineering, decompilation, or derivative works are prohibited.
 */

// src/components/Layout/Layout.js
import React from 'react';
import styled from 'styled-components';
import Sidebar from './Sidebar';
import Header from './Headers';
import { motion } from 'framer-motion';

const LayoutContainer = styled.div`
  display: flex;
  min-height: 100vh;
`;

const ContentContainer = styled.div`
  flex: 1;
  display: flex;
  flex-direction: column;
  overflow-x: hidden;
`;

const Main = styled(motion.main)`
  flex: 1;
  padding: ${({ theme }) => theme.spacing[6]};
  
  @media (max-width: 768px) {
    padding: ${({ theme }) => theme.spacing[4]};
  }
`;

const Layout = ({ children }) => {
    return (
        <LayoutContainer>
            <Sidebar />
            <ContentContainer>
                <Header />
                <Main
                    initial={{ opacity: 0, y: 20 }}
                    animate={{ opacity: 1, y: 0 }}
                    transition={{ duration: 0.3 }}
                >
                    {children}
                </Main>
            </ContentContainer>
        </LayoutContainer>
    );
};

export default Layout;